//import * as BABYLON from 'babylonjs';
import VisualComponent from './VisualComponent';
//import MediaManager from '@/api/MediaManager';

class Image extends VisualComponent {
    getType() { return "Image"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct( context, prefab ) {
        const base = super.construct( context, prefab );

        //console.log("Image construct...");
        return base;
    }
    

}

export default Image;

